export default "__VITE_ASSET__CBQURsLD__"